import { render, staticRenderFns } from "./EditPlacementAnchorCard.vue?vue&type=template&id=6cd3b3fc&scoped=true&"
import script from "./EditPlacementAnchorCard.vue?vue&type=script&lang=js&"
export * from "./EditPlacementAnchorCard.vue?vue&type=script&lang=js&"
import style0 from "./EditPlacementAnchorCard.vue?vue&type=style&index=0&id=6cd3b3fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd3b3fc",
  null
  
)

export default component.exports